import {
  ForwardedRef,
  forwardRef,
  ReactHTML,
  ReactNode,
  createElement,
  DetailedHTMLProps,
  HTMLAttributes,
  CSSProperties,
} from 'react'

type BlockProps = {
  children?: ReactNode
  className?: string
  type?: keyof ReactHTML
  style?: CSSProperties
} & DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>

const Block = forwardRef(
  (
    { children, type = 'div', className, style, ...other }: BlockProps,
    ref: ForwardedRef<HTMLElement>
  ) =>
    createElement(
      type,
      {
        ...other,
        ref,
        className,
        style,
      },
      children
    )
)

Block.displayName = 'Block'

export default Block
